import { Button, Col, Descriptions, List, Row, Space, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import myinvoisTransService from '../../../services/myinvois/myinvois_trans.service';
import { Link } from 'react-router-dom';
import numberHelper from '../../../helpers/functions/number.helper';

const MyInvoisDocumentList = ({ submission_id, }) => {
    const [state, setState] = useState({
        loading : false,
        documents : [],

        // pagination
        page : 0,
        display_size : 10,
        count : null,
    })

    const fetchDocuments = async () => {
        setState(state => ({...state, loading : true, }));

        const documentListResponse = await myinvoisTransService?.getMyInvoisDocumentList({
            submission_id,
        })

        const { count, rows : documents, } = documentListResponse?.documents;

        setState(state => ({...state, loading : false, documents, count, }));
    }

    useEffect(() => {
        fetchDocuments();
    }, [submission_id])

    return (
        <>
            <List
            size='small'
            loading={state?.loading}
            dataSource={state?.documents}
            renderItem={(item, index) => {
                const { document_id, ticket_id, document_line_count, myinvois_document_id, document_type_version, document_type, status, amount, unique_no, } = item ?? {};
                return (
                    <List.Item>
                        <div style={{ display : 'flex', width : '100%', alignContent : 'start', }}>
                            <div>
                                <Descriptions
                                size='small'
                                colon={false}
                                layout='vertical'
                                items={[{
                                    key : 'myinvois_document_id',
                                    label : 'Document ID',
                                    children : myinvois_document_id,
                                },{
                                    key : 'document_type_version',
                                    label : 'Document Type Version',
                                    children : document_type_version,
                                },{
                                    key : 'status',
                                    label : 'Status',
                                    children : (
                                        <Tag color={status === 'Valid' ? 'success' : 'error'}>{status}</Tag>
                                    ),
                                },{
                                    key : 'type',
                                    label : 'Document Type',
                                    children : document_type,
                                },{
                                    key : 'amount',
                                    label : 'Amount',
                                    children : (
                                        <span>RM{numberHelper?.commaNumber(parseFloat(amount) ?? 0)}</span>
                                    ),
                                },{
                                    key : 'document_line_count',
                                    label : 'Submitted Ticket Count',
                                    children : document_line_count,
                                }]}
                                />
                            </div>

                            <div style={{ marginLeft : 'auto', }}>
                                <Link to={`myinvois/detail/${document_id}`}>
                                    <Button>View</Button>
                                </Link>
                            </div>
                        </div>
                    </List.Item>
                )
            }}
            />
        </>
    );
}

export default MyInvoisDocumentList;